
export default function AboutContent() {
  return (
    <div className="bg-white">
      {/* First Section - Image Left with Overlapping Card */}
      <div className="relative py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-0">
            <div className="lg:w-1/2 relative z-0 w-full">
              <div className="relative h-[320px] sm:h-[420px] lg:h-[500px] w-full rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_8b816a0a15d96081a03f233505bfc2c7_36db5487.jpg"
                  alt="Professional painter working on ceiling with precision"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 bg-amber-500 rounded-2xl -z-10"></div>
            </div>
            <div className="lg:w-1/2 lg:pl-16">
              <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">About Our Craft</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Professional Painting & Decorating Services
              </h2>
              <div className="space-y-4">
                <p className="text-gray-600 leading-relaxed">
                  With over 18 years of experience, Brushour are committed to delivering exceptional painting and decorating services across Hertfordshire. Our team of skilled professionals takes pride in transforming homes and businesses with meticulous attention to detail.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  We understand that your property is one of your most valuable assets. That's why we treat every project—whether it's a single room refresh or a complete property makeover—with the same level of care and professionalism.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  From initial consultation to final inspection, we work closely with our clients to ensure their vision becomes reality.
                </p>
              </div>
              <div className="mt-8 flex items-center gap-6">
                <div className="text-center">
                  <span className="block text-3xl font-bold text-amber-600">18+</span>
                  <span className="text-sm text-gray-500">Years Experience</span>
                </div>
                <div className="w-px h-12 bg-gray-200"></div>
                <div className="text-center">
                  <span className="block text-3xl font-bold text-amber-600">500+</span>
                  <span className="text-sm text-gray-500">Projects Done</span>
                </div>
                <div className="w-px h-12 bg-gray-200"></div>
                <div className="text-center">
                  <span className="block text-3xl font-bold text-amber-600">100%</span>
                  <span className="text-sm text-gray-500">Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Section - Image Right with Different Style */}
      <div className="relative py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-0">
            <div className="lg:w-1/2 relative lg:pl-8">
              <div className="relative h-[500px] w-full rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fb820ae8f9dfd495eb488818a5eca08e4&methods=resize%2C1000%2C5000"
                  alt="Kitchen painted in Rickmansworth"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="hidden lg:block absolute -top-6 -left-6 w-32 h-32 bg-amber-500 rounded-2xl -z-10"></div>
            </div>
            <div className="lg:w-1/2 lg:pr-16">
              <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-4">Local Experts</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Painters and Decorators in Watford
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                Careful preparation, expert application, final detailing, and thorough clean-up are all part of our work process to deliver the quality results you expect. We care about your peace of mind and are committed to your complete satisfaction.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-600">Detailed and complete estimates with no hidden fees</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-600">All products and labour included in your quote</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-600">Every project guaranteed and completed as contracted</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-600">Highly recommended by customers who call us again and again</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
